import { useState } from "react";
import Button from "shared/UI/Buttons/Button";
import { BottomSheet } from "UIPalette/BottomSheet/BottomSheet";
import { AiBadge, WisdomAIOnboarding } from "../../WisdomAI/components/WisdomAIOnboarding";

export const ComponentsWisdomAI = () => {
  const [isOnboardingOpen, setIsOnboardingOpen] = useState(false);
  const [isInfoSheetOpen, setIsInfoSheetOpen] = useState(false);

  return (
    <div className="space-y-8">
      <Button className="max-w-[300px]" text="Start Wisdom AI onboarding" onClick={() => setIsOnboardingOpen(true)} />
      <Button className="max-w-[300px]" variant="outline" text="Open dismissible sheet" onClick={() => setIsInfoSheetOpen(true)} />

      <WisdomAIOnboarding isOpen={isOnboardingOpen} onClose={() => setIsOnboardingOpen(false)} />

      <BottomSheet
        isOpen={isInfoSheetOpen}
        title="Welcome to Wisdom AI"
        header={<AiBadge />}
        onClose={() => setIsInfoSheetOpen(false)}
        footer={<Button text="Continue" onClick={() => setIsInfoSheetOpen(false)} />}
      >
        <p>Before you begin, it's important that you understand how your information will be handled.</p>
      </BottomSheet>
    </div>
  );
};
